/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { checkAuth } from 'common/utils/ActionUtils'
import { toast } from 'react-toastify'

const JenkinsAction = {
    launchService:
        async (job) => {
            try {
                toast.info(`Lancement du job : ${job}`)
                await fetch(ApplicationConf.jenkins.launchJob(job), {
                    method: 'POST',
                    headers: {
                        Authorization: 'Basic anVsaWVuLnJvYmE6MTFmZDRmZjIxODlmNGRjMzhhZmQ0MWQ2NzM1NzYyYmE4Mg==',
                        // Authorization: `Basic ${window.btoa('aquaparc:11fd4ff2189f4dc38afd41d6735762ba82')}`,
                        'Content-Type': 'application/json',
                    },
                })
                    .then(checkAuth)
            } catch (err) {
                console.error(err)
                toast.error(`Erreur lors du lancement du job : ${job}`)
            }
        },
}

export default JenkinsAction